import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import InformativeModalLayout from '../InformativeModalLayout';
import BasicModalLayoutFooter from '../ModalLayout/BasicModalLayoutFooter';
import ExitToDashboardSvg from '../InformativeModalLayout/ExitToDashboardSvg';
import { Modal } from 'wix-style-react';

function NavigateAwayModal({ isOpen, onRequestClose, navigateAwayModalClose, t }) {
  const footer = (
    <BasicModalLayoutFooter
      okText={t('phoneordering_customerinfo_popup_abandon_CTA_Primary')}
      cancelText={t('phoneordering_common_CTA_cancel')}
      okSkin="destructive"
      onCancelClick={() => {
        navigateAwayModalClose({ shouldResumeNavigation: false });
        onRequestClose();
      }}
      onOkClick={() => {
        navigateAwayModalClose({ shouldResumeNavigation: true });
      }}
    />
  );

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} shouldCloseOnOverlayClick>
      <InformativeModalLayout
        dataHook="back-to-dashboard-modal"
        title={t('phoneordering_customerinfo_popup_abandon_title')}
        content={t('phoneordering_customerinfo_popup_abandon_text')}
        onRequestClose={onRequestClose}
        footer={footer}
        illustration={<ExitToDashboardSvg />}
      />
    </Modal>
  );
}

NavigateAwayModal.displayName = 'NavigateAwayModal';
NavigateAwayModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  clearCustomerSession: PropTypes.func,
};

export default translate()(NavigateAwayModal);
